import { Link } from 'react-router-dom';
import { ArrowLeft, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ContactFormSection } from '@/components/contact/contact-form-section';
import { useTenant } from '@/providers/tenant-context';

export default function ContactPage() {
  const { tenant, isWhitelabel } = useTenant();

  return (
    <div className="flex flex-col min-h-screen bg-background relative overflow-x-hidden transition-colors duration-300 font-sans">
      <div className="fixed inset-0 -z-10 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary/10 via-background to-background pointer-events-none" />
      <div className="fixed inset-0 w-full h-full -z-10 opacity-[0.03] bg-[url('https://grainy-gradients.vercel.app/noise.svg')] pointer-events-none" />

      <header className="fixed top-0 w-full z-50 border-b border-border/10 bg-background/60 backdrop-blur-xl">
        <div className="container mx-auto px-6 h-20 flex items-center justify-between">
          <Link className="flex items-center gap-2 group" to="/">
            {isWhitelabel && tenant?.logoWithName ? (
              <img
                src={tenant.logoWithName}
                alt={tenant.name}
                className="h-10 w-auto object-contain group-hover:scale-105 transition-transform duration-300"
              />
            ) : (
              <>
                <img
                  src={isWhitelabel && tenant?.logo ? tenant.logo : '/milora-logo.png'}
                  alt={isWhitelabel ? tenant?.name : 'Milora'}
                  className="w-10 h-10 object-contain group-hover:scale-105 transition-transform duration-300"
                />
                <span className="font-bold text-2xl tracking-tighter text-foreground">
                  {isWhitelabel ? tenant?.name : 'Milora'}
                </span>
              </>
            )}
          </Link>
          <div className="flex items-center gap-4">
            <Link to="/">
              <Button variant="ghost" className="rounded-full gap-2">
                <ArrowLeft className="h-4 w-4" />
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1 pt-20">
        <div className="container px-6 mx-auto pt-12 pb-4 max-w-4xl text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-xs font-semibold text-primary uppercase tracking-wider mb-4">
            <Mail className="h-3 w-3" />
            <span>Contact</span>
          </div>
        </div>
        <ContactFormSection />
      </main>

      <footer className="py-12 px-6 border-t border-border/40 bg-muted/20">
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
          <p className="text-sm text-muted-foreground/60">
            © {new Date().getFullYear()} Simplium Technologies LLP
          </p>
          <nav className="flex flex-wrap gap-4 md:gap-8 justify-center">
            <Link
              className="text-sm text-muted-foreground hover:text-primary transition-colors whitespace-nowrap"
              to="/privacy"
            >
              Privacy
            </Link>
            <Link
              className="text-sm text-muted-foreground hover:text-primary transition-colors whitespace-nowrap"
              to="/csae"
            >
              CSAE Standards
            </Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
